import React, { useState } from "react";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
// import bannerImg from "../images/login-side-banner.svg";
import { RiEyeOffFill, RiEyeFill } from "react-icons/ri";
import bannerImg from "./images/signup-side-banner.svg";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Login(props) {
  //call the useNavigaye function
  const navigate = useNavigate();

  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [userToken, setUserToken] = useState("");

  // utiliity functions
  const handleChange = (event) => {
    setLogin((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  // Hadle user token
  const getUserToken = (userData) => {
    const token = userData.data.accessToken;
    setUserToken(token);
  };

  // Handle error message
  const handleErrorMessage = (err) => {
    const error = err.message[0].msg || err.message;
    setErrorMessage(error);
  };

  const togglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      email: login.email,
      password: login.password,
    };

    // turn on the laoding
    setLoading(true);

    try {
      const response = await fetch(
        `https://studyapp-api.vercel.app/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const userData = await response.json();

      console.log(userData);

      handleErrorMessage(userData);

      getUserToken(userData);

      setLogin((prev) => {
        return {
          ...prev,
          ...userData,
        };
      });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // store the  user token in local storage
  localStorage.setItem("myToken", userToken);

  return (
    <>
      {/* import header component */}
      <Header />

      <section className="login-container">
        <div className="flex-2">
          <form className="form-container" onSubmit={handleSubmit}>
            <div className="form-wrapper">
              <div className="form-header">
                <h3>login to your account</h3>
                <p>Please select a login method</p>
              </div>
              <div className="form-body">
                <div className="form-field">
                  <label htmlFor="email">email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={login.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="password">password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={login.password}
                    onChange={handleChange}
                  />
                  <span onClick={togglePasswordVisibilty} className="eye-icon">
                    {showPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                  </span>
                </div>
              </div>
              {/* return error message*/}
              {login.status === "success" ? (
                navigate("/dashboard")
              ) : (
                <span style={{ color: "red" }}>{errorMessage}</span>
              )}
              <div className="form-footer">
                <div className="form-field">
                  <div className="cta-btn">
                    <button>sign in</button>
                  </div>
                  {loading ? (
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  ) : null}
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "1.2rem",
                      fontWeight: "600",
                    }}
                  >
                    or
                  </p>
                </div>
                <div className="form-field google-btn">
                  <div className="cta-btn">
                    <button>
                      <span>sign in with google</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="side-banner-img">
            <img src={bannerImg} alt={"our users"} />
          </div>
        </div>
        <div className="inner-flex-2">
          <p className="have-an-accout">
            <span className="login_signup">
              <Link to="/forgot-password">Forgot password</Link>
            </span>
          </p>
          <p className="have-an-account">
            Don't have an account ? {""}
            <span className="login_signup">
              <Link to="/signup">Sign up</Link>
            </span>
          </p>
        </div>
      </section>
    </>
  );
}

export default Login;
